import { palette } from '@/theme/constants';


export const styles = (color?: string)=>({
  inputMobile: {
   // border: `0.063rem solid ${palette.cardBorder}`,
    background: color,

    color: palette.white,
    borderRadius: '10px',

    '& .MuiOutlinedInput-root': {
      borderRadius: '10px',
      paddingLeft: '6px',
      paddingRight: '6px',
    },
    '& .MuiOutlinedInput-input': {
      height: '2.375rem',
      borderRadius: '10px',
      color: palette.white,
    },
  },
  paperMobileExpanded: {
    flexGrow: 1,
    gap: '0.5rem',
  },
});
